import React from 'react';
import { Play } from 'lucide-react';

export const LatestTutorials = () => (
  <section className="bg-gray-50 py-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl font-bold mb-8">Latest Tutorials</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[
          {
            title: "Advanced PivotTables",
            duration: "15:30",
            views: "2.4k",
            image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=600&q=80"
          },
          {
            title: "Power Query Mastery",
            duration: "22:15",
            views: "1.8k",
            image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=600&q=80"
          },
          {
            title: "Excel Automation",
            duration: "18:45",
            views: "3.1k",
            image: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?auto=format&fit=crop&w=600&q=80"
          }
        ].map((tutorial, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden group cursor-pointer">
            <div className="relative">
              <img src={tutorial.image} alt={tutorial.title} className="w-full h-48 object-cover" />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Play className="h-12 w-12 text-white" />
              </div>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2">{tutorial.title}</h3>
              <div className="flex items-center text-gray-600 text-sm">
                <span className="mr-4">{tutorial.duration}</span>
                <span>{tutorial.views} views</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);